import { Typography } from "@mui/material";
import { ReactElement } from "react";

import { FlexBox } from "~frontend/components/FlexBox";
import { InternalLink } from "~frontend/components/Link";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";

export function InboxArchived(): ReactElement {
  const { subaccountLink } = useSubaccount()!;

  return (
    <FlexBox
      sx={{
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Typography variant="h1">This campaign has been archived.</Typography>
      <InternalLink
        variant="body1Bold"
        underline="none"
        to={subaccountLink(`/inboxes/`)}
      >
        {"< Back to your campaigns"}
      </InternalLink>
    </FlexBox>
  );
}
